"use client";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect, useRef, useState } from "react";
import StatsBar from "src/components/molecules/TechEventsSection/StatsBar";
import BottomBanner from "src/components/molecules/TechEventsSection/BottomBanner";
import TechHeroSection from "src/components/molecules/TechEventsSection/TechHeroSection";
import EmpoweringBanner from "src/components/molecules/TechEventsSection/EmpoweringBanner";
import YearlyEventsTimeline from "src/components/molecules/TechEventsSection/YearlyEventsTimeline";

gsap.registerPlugin(ScrollTrigger);

const groupEventsByYear = (events = []) => {
  const map = {};

  events.forEach((event) => {
    const yearNum = event.year?.year;
    if (!yearNum) return;

    if (!map[yearNum]) {
      map[yearNum] = {
        year: yearNum,
        description: event.year?.description || "",
        yearPhoto: event.year?.yearPhoto || null,
        totalEvents: event.year?.totalEvents || 0,
        events: [],
      };
    }
    map[yearNum].events.push(event);
  });

  return Object.values(map).sort((a, b) => b.year - a.year);
};

const TechEventsComponents = ({ eventList = [] }) => {
  const yearGroups = groupEventsByYear(eventList);
  const years = yearGroups.map((g) => g.year);
  const [activeYear, setActiveYear] = useState(years[0]);
  const progressRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.to(progressRef.current, {
        scaleX: 1,
        ease: "none",
        scrollTrigger: {
          start: 0,
          end: "max",
          scrub: 0.3,
        },
      });
    });
    return () => ctx.revert();
  }, []);

  return (
    <div className="relative bg-background-primary text-text-primary min-h-screen overflow-hidden">
      <div
        ref={progressRef}
        className="fixed top-0 left-0 right-0 h-[3px] origin-left scale-x-0 z-50"
        style={{ background: "linear-gradient(90deg, #6366f1, #a855f7, #6366f1)" }}
      />
      <TechHeroSection years={years} totalEvents={eventList.length} />

      <EmpoweringBanner totalEvents={eventList.length} />

      <div className="relative bg-background-primary">
        {yearGroups.map((group, i) => (
          <YearlyEventsTimeline key={group.year} yearData={group} index={i} onActive={setActiveYear} />
        ))}
      </div>

      <StatsBar />
      <BottomBanner />
    </div>
  );
};

export default TechEventsComponents;
